export type LendingApiErrorResponse = {
  errors: {
    code: string;
    detail: string;
  }[];
};

export class LendingApiError extends Error {
  constructor(
    apiResponse: LendingApiErrorResponse | undefined,
    statusCode: number,
  ) {
    const errorMessage =
      apiResponse === undefined || apiResponse.errors.length === 0
        ? 'Unknown error'
        : apiResponse.errors.map((e) => `${e.code}: ${e.detail}`).join(', ');

    super(`${statusCode} - ${errorMessage}`);
    this.name = 'LendingApiError';
  }
}
